<!--
 * Description  :
 * Date         :2021-11-01 14:02:38
 * LastEditors  :chenjia
 * LastEditTime :2024-06-20 15:51:03
 * FilePath     :\aomei-pay\src\views\RegistrationCode.vue
-->
<template>
  <div class="result">
    <ul class="bread f-dpf">
      <li class="bread-it actived">
        确认订单
        <i class="bread-ic"><span>1</span></i>
      </li>
      <li class="bread-it actived">
        支付
        <i class="bread-ic"><span>2</span></i>
      </li>
      <li class="bread-it active">
        获取注册码
        <i class="bread-ic"><span>3</span></i>
      </li>
    </ul>

    <div class="re-x">
      <h2 class="s-fc-wt">
        <span class="ic-x"><i class="el-icon-success s-fc-success"></i></span>购买成功
      </h2>
      <div class="mn-cnt">
        <div class="mn-top">
          <div class="img-x">
            <img src="../assets/pic1.png" alt="" width="261" height="194" />
          </div>
          <div class="txt-x">
            <p>
              订单号：<span>{{ productDetails.order_no }}</span>
            </p>
            <p>
              软件名：<span>{{ productDetails.show_name }}</span>
            </p>
            <p>
              版本：<span>{{ productDetails.show_version }}</span>
            </p>
            <p>
              软件数量：<span>{{ productDetails.data.length }}</span>
            </p>
          </div>
        </div>
        <div class="g-ls" v-for="(item, index) in productDetails.data" :key="index">
          <h3>{{ item.soft_name + item.subtitle }}注册码</h3>
          <!-- <p>{{ item.subtitle }}</p> -->
          <div class="table-x" v-if="windowWidth > 768">
            <el-table class="table table-bl" :data="item.serial_numbers" border style="width: 100%">
              <el-table-column prop="id" label="编号" min-width="120"> </el-table-column>
              <el-table-column prop="code" label="注册码" min-width="300px"> </el-table-column>
            </el-table>
          </div>

          <div v-loading="tableLoading" class="phone-table" v-else style="margin: 20px 0 30px">
            <el-row v-for="it in item.serial_numbers" :key="it.id" class="vertical-table">
              <el-col :span="24">
                <div class="text item"><strong>编号:</strong>{{ it.id }}</div>
                <div class="text item"><strong>注册码:</strong> {{ it.code }}</div>
              </el-col>
            </el-row>
          </div>

          <div class="btm">
            <p>下载地址：</p>
            <a :href="item.download_url">{{ item.download_url }}</a>
          </div>
        </div>
      </div>

      <div class="email-x">
        已将购买信息发送到<span class="s-fc-bl">{{ userEmail }}</span
        >，请注意查收！
      </div>
    </div>
    <div class="btn-bx">
      <el-button
        class="btn btn-bl-org"
        type="primary"
        @click="sendEmail"
        :disabled="sendEmailBtn.disable"
        >{{ sendEmailBtn.txt }}</el-button
      >
      <el-button class="btn btn-bl-org" type="primary"
        ><a target="_blank" href="https://www.abackup.com/get-offline-key.html"
          >离线激活码</a
        ></el-button
      >
      <el-button class="btn btn-bl-org" type="primary" @click="handleOpenInvoice"
        >开具发票</el-button
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import * as api from "../api/api";
// import { mapState } from "vuex";
import windowWidthMixin from "@/mixins/windowWidthMixin";
export default {
  name: "RegistrationCode",
  components: {},
  mixins: [windowWidthMixin],
  data() {
    return {
      sendEmailBtn: {
        txt: "重新发送到邮箱",
        time: 60,
        disable: false
      }
    };
  },
  computed: {
    userEmail() {
      return this.$store.state.user.email;
    },
    productDetails() {
      const rawData = JSON.parse(this.$store.state.orderInfo);
      const dealData = (({ order_no, show_name, show_version, subtitle, soft_name, data }) => {
        //处理序列号
        data.forEach((n, i) => {
          let liceseCode = [];
          console.log(n, i, liceseCode);
          n.serial_numbers.forEach((item, j) => {
            liceseCode.push({
              id: j + 1,
              code: item
            });
          });
          data[i].serial_numbers = liceseCode;
        });
        return {
          order_no,
          show_name,
          show_version,
          subtitle,
          soft_name,
          data
        };
      })(rawData);

      return dealData;
    }
  },
  methods: {
    gotoInvoice() {
      this.$router.push({ path: "invoice" });
    },
    handleOpenInvoice() {
      this.$router.push("/invoice");
    },
    sendEmail() {
      api.sendEamil(this.productDetails.order_no).then(() => {
        this.sendEmailBtn.disable = true;
        const countDown = setInterval(() => {
          if (this.sendEmailBtn.time < 1) {
            this.sendEmailBtn = {
              disable: false,
              txt: "重新发送到邮箱",
              time: 60
            };
            clearInterval(countDown);
          } else {
            this.sendEmailBtn.txt = this.sendEmailBtn.time-- + "s后重新发送";
          }
        }, 1000);
      });
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.result {
  padding-top: 25px;
  h2 {
    margin-bottom: 45px;
    font-size: 40px;
    text-align: center;
    i {
      margin-right: 10px;
      font-size: 70px;
      vertical-align: middle;
      vertical-align: middle;
      position: absolute;
      top: -17px;
      right: 0;
      left: -16px;
      bottom: 0;
    }
    .ic-x {
      // background-color: #fff;
      vertical-align: middle;
      width: 30px;
      background: #fff;
      height: 30px;
      width: 40px;
      background: #fff;
      height: 40px;
      display: inline-block;
      margin-right: 35px;
      position: relative;
    }
  }
  .re-x {
    background: url(../assets/bg-title.png) no-repeat center top #fff;
    background-size: 100% auto;
    padding: 60px 100px 40px;
    border-radius: 10px;
    .mn-cnt {
      background: #fff;
      width: 100%;
      padding: 55px;
      box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
      border-radius: 10px;
    }
    .mn-top {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin-bottom: 80px;
      .img-x {
        margin-right: 60px;
      }
      .txt-x {
        p:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
    .g-ls {
      max-width: 600px;
      margin: 0 auto;
      h3 {
        margin-bottom: 5px;
      }
      &:not(:last-child) {
        margin-bottom: 80px;
      }
    }
    .table-x {
      max-width: 600px;
      margin: 20px auto 0 auto;
      table {
        width: 100%;
        font-size: 16px;
        color: #333;
        th {
          background-color: #39449f;
          color: #fff;
          padding-left: 50px;
          border-color: #e6e7ec;
        }
        td {
          padding-left: 50px;
          background: #f2f2f2;
          border-color: #e6e7ec;
        }
        th:first-child,
        td:first-child {
          text-align: center;
          padding: 0 5px;
        }
      }
    }
    .btm {
      max-width: 600px;
      margin: 30px auto 0 auto;
      font-size: 16px;
    }
  }
  .email-x {
    text-align: center;
    background: #f2f2f2;
    border-radius: 10px;
    font-size: 22px;
    padding: 14px 20px;
    margin-top: 35px;
    color: #111;
  }
  .btn-bx {
    margin-top: 60px;
    margin-bottom: 85px;
    text-align: center;
    .el-button + .el-button {
      margin-left: 40px;
    }
  }
}

@media (min-width: 992px) {
  .table-x {
    /deep/ th:nth-child(2),
    /deep/ td:nth-child(2) {
      padding-left: 40px;
      text-align: left;
    }
  }
}

@media (max-width: 1024px) {
  .result {
    .re-x {
      padding: 60px 15px 40px;
    }
  }
}
@media (max-width: 767px) {
  .result {
    padding-top: 0;
    .re-x {
      .mn-cnt {
        padding: 0;
        box-shadow: none;
      }
      .img-x {
        padding: 0;
      }
      .mn-top {
        flex-direction: column;
        font-size: 14px;
        margin-bottom: 40px;
        .img-x {
          margin: 0;
        }
      }
      .btm {
        font-size: 14px;
      }
    }
    .email-x {
      font-size: 16px;
    }
    .btn-bx {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 40px 0;
      .el-button + .el-button {
        margin-left: 0;
        margin-top: 20px;
      }
    }
  }
}
</style>
